import { Menu, Text } from "@mantine/core"
import type { ReactElement, ReactNode } from "react"

export type LanguageItem = {
  label: string
  value: string
  icon: ReactElement
}

type Props = {
  variant?: "light" | "dark"
  currentLocale: string
  languageItems: LanguageItem[]
  handleLanguageChange: (locale: string) => void
  trigger?: ReactNode // New prop for custom trigger
  dropDownPosition?: "top" | "bottom" | "left" | "right"
}

export const AppLanguageMenu = ({
  variant = "light",
  languageItems,
  currentLocale,
  handleLanguageChange,
  trigger,
  dropDownPosition = "bottom",
}: Props) => {
  const sortedItems = languageItems
    .map((languageItem) => ({
      label: languageItem.label,
      icon: languageItem.icon,
      onClick: () => handleLanguageChange(languageItem.value),
    }))
    .sort((li1, li2) => li1.label.localeCompare(li2.label))

  const defaultTrigger = (
    <Text c={variant === "light" ? "var(--mantine-color-text)" : "white"}>
      {currentLocale}
    </Text>
  )

  return (
    <Menu width="fit-content" position={dropDownPosition}>
      <Menu.Target>{trigger || defaultTrigger}</Menu.Target>
      <Menu.Dropdown>
        {sortedItems.map((item, index) => (
          <Menu.Item key={index} leftSection={item.icon} onClick={item.onClick}>
            {item.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}
